export default "/images/globe-icon.png?f31597cb388c544442bc8b81213abe0a";